import { NgClass, NgIf } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ZopConfirmationConfig } from '../confirmation.types';

@Component({
    selector: 'zop-confirmation-dialog',
    templateUrl: './dialog.component.html',
    styles: [
        `
      .zop-confirmation-dialog-panel {
        @apply md:w-128;

        .mat-mdc-dialog-container {
          .mat-mdc-dialog-surface {
            padding: 0 !important;
          }
        }
      }
    `,
    ],
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, MatButtonModule, MatDialogModule, MatIconModule, NgClass]
})
export class ZopConfirmationDialogComponent {
  /**
   * Constructor
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: ZopConfirmationConfig) {}
}
